/* ==========================================================================
   GutNourish theme — theme.js
   No dependencies. Progressive enhancement: every control works as a plain
   form/link if JavaScript never runs.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------- money */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    function withComma(n, decimals) {
      var value = (n / 100).toFixed(decimals);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
      switch (name) {
        case 'amount': return withComma(cents, 2);
        case 'amount_no_decimals': return withComma(cents, 0);
        case 'amount_with_comma_separator': return withComma(cents, 2).replace(/[,.]/g, function (c) { return c === ',' ? '.' : ','; });
        case 'amount_no_decimals_with_comma_separator': return withComma(cents, 0).replace(/[,.]/g, function (c) { return c === ',' ? '.' : ','; });
        default: return withComma(cents, 2);
      }
    });
  }
  window.formatMoney = formatMoney;

  /* ------------------------------------------------------------ toasts */
  function toast(message) {
    var region = $('#ToastRegion');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    region.appendChild(el);
    setTimeout(function () { el.remove(); }, 3200);
  }

  /* --------------------------------------------------- focus trapping */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var trapState = null;

  function trapFocus(container, opener) {
    releaseTrap();
    var first = $$(FOCUSABLE, container)[0];
    function onKey(e) {
      if (e.key === 'Escape') { closeAllPanels(); return; }
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var firstEl = items[0], lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }
    document.addEventListener('keydown', onKey);
    trapState = { onKey: onKey, opener: opener };
    if (first) first.focus();
  }

  function releaseTrap() {
    if (!trapState) return;
    document.removeEventListener('keydown', trapState.onKey);
    if (trapState.opener && document.body.contains(trapState.opener)) trapState.opener.focus();
    trapState = null;
  }

  /* ------------------------------------------------------------ panels */
  var overlay = null;

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'overlay';
    overlay.addEventListener('click', closeAllPanels);
    document.body.appendChild(overlay);
    return overlay;
  }

  function openPanel(panel, opener) {
    if (!panel) return;
    ensureOverlay().classList.add('is-open');
    panel.classList.add('is-open');
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    trapFocus(panel, opener);
  }

  function closeAllPanels() {
    $$('.cart-drawer.is-open, .menu-drawer.is-open, .searchpop.is-open').forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    releaseTrap();
  }

  window.closeAllPanels = closeAllPanels;

  /* -------------------------------------------------------------- cart */
  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || T.strings.cartError);
        return data;
      });
    });
  }

  function refreshCart() {
    return fetch(T.routes.cartJson).then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    });
  }

  function renderCartDrawer() {
    return fetch(T.routes.cart + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-drawer-inner]', doc);
      var current = $('[data-cart-drawer-inner]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    });
  }

  function addToCart(payload, opener) {
    return cartFetch(T.routes.cartAdd, payload)
      .then(function () { return Promise.all([refreshCart(), renderCartDrawer()]); })
      .then(function () {
        if (T.cartType === 'drawer') openPanel($('#CartDrawer'), opener);
        else window.location.href = T.routes.cart;
      })
      .catch(function (err) { toast(err.message); throw err; });
  }

  window.addToCart = addToCart;

  function changeLine(key, quantity, row) {
    if (row) row.classList.add('is-busy');
    return cartFetch(T.routes.cartChange, { id: key, quantity: quantity })
      .then(function () { return Promise.all([refreshCart(), renderCartDrawer()]); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function (err) { toast(err.message); if (row) row.classList.remove('is-busy'); });
  }

  /* ------------------------------------------------------- delegation */
  document.addEventListener('click', function (e) {
    var openCart = e.target.closest('[data-open-cart]');
    if (openCart && T.cartType === 'drawer') {
      e.preventDefault();
      renderCartDrawer().then(function () { openPanel($('#CartDrawer'), openCart); });
      return;
    }

    var openMenu = e.target.closest('[data-open-menu]');
    if (openMenu) { e.preventDefault(); openPanel($('#MenuDrawer'), openMenu); return; }

    if (e.target.closest('[data-close-panel]')) { e.preventDefault(); closeAllPanels(); return; }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0, remove.closest('.line-item'));
      return;
    }

    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      var row = step.closest('[data-line-key]');
      var input = $('input', step.parentNode);
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-line-step'), 10));
      input.value = next;
      changeLine(row.getAttribute('data-line-key'), next, row);
      return;
    }

    var qtyStep = e.target.closest('[data-qty-step]');
    if (qtyStep) {
      e.preventDefault();
      var qInput = $('input', qtyStep.parentNode);
      var v = Math.max(1, parseInt(qInput.value || '1', 10) + parseInt(qtyStep.getAttribute('data-qty-step'), 10));
      qInput.value = v;
      qInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var acc = e.target.closest('[data-accordion-toggle]');
    if (acc) {
      var open = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', String(!open));
      var target = document.getElementById(acc.getAttribute('aria-controls'));
      if (target) target.hidden = open;
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var lineInput = e.target.closest('[data-line-qty]');
    if (lineInput) {
      var row = lineInput.closest('[data-line-key]');
      changeLine(row.getAttribute('data-line-key'), parseInt(lineInput.value, 10), row);
    }
  });

  /* -------------------------------------------------------------- tabs */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    if (!tabs.length) return;
    function show(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { show(tab); });
      tab.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0);
        if (!d) return;
        e.preventDefault();
        var next = tabs[(i + d + tabs.length) % tabs.length];
        show(next); next.focus();
      });
    });
  }

  /* ----------------------------------------------------------- gallery
     Slides are pre-rendered and stacked; moving between them just toggles a class, so there
     is no image swap and no network wait. Driven by thumbnails, arrows, keyboard and swipe.  */
  function initGallery(root) {
    var gal = $('[data-gallery]', root) || root;
    var slides = $$('[data-gallery-slide]', gal);
    if (slides.length < 2) return;

    var thumbs = $$('[data-gallery-thumb]', gal);
    var counter = $('[data-gallery-current]', gal);
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;      // wraps both ways
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === index)); });
      if (counter) counter.textContent = String(index + 1);
      // Warm the neighbours so the next move is instant even on a slow connection.
      [index + 1, index - 1].forEach(function (n) {
        var s = slides[(n + slides.length) % slides.length];
        // a theme-side slide is a wrapper around its image
        var im = s && (s.tagName === 'IMG' ? s : s.querySelector('img'));
        if (im && im.loading === 'lazy') { im.loading = 'eager'; }
      });
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = $('[data-gallery-prev]', gal), next = $('[data-gallery-next]', gal);
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    // Swipe. Tracked on the main image only, and ignored unless the gesture is clearly
    // horizontal, so it never steals a vertical page scroll on a phone.
    var main = $('.gallery__main', gal);
    if (main) {
      var x0 = null, y0 = null;
      main.addEventListener('touchstart', function (e) {
        x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(index + (dx < 0 ? 1 : -1)); }
        x0 = y0 = null;
      }, { passive: true });
    }

    show(0);
  }

  /* ------------------------------------------------------- sticky ATC */
  function initSticky() {
    var bar = $('[data-sticky-bar]');
    var anchor = $('[data-sticky-anchor]');
    var trigger = $('[data-sticky-trigger]');
    var foot = $('.footer');
    if (!bar || !anchor) return;
    function inView(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }
    /* With a trigger (the main Add to cart button), the bar appears once that button has scrolled
       up out of view, under the sticky header (Owen, 25 Sep). Without one, the original rule:
       once the whole product section is out of view. */
    function headerBottom() {
      var h = $('.header');
      if (!h) return 0;
      var pos = window.getComputedStyle(h).position;
      return (pos === 'sticky' || pos === 'fixed') ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
    }
    function onScroll() {
      var on = trigger
        ? trigger.getBoundingClientRect().bottom < headerBottom() && !inView(foot)
        : window.scrollY > window.innerHeight * 0.6 && !inView(anchor) && !inView(foot);
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------------------------------------------------- search popup */
  function initSearch() {
    var pop = $('#SearchPop');
    if (!pop) return;

    var input = $('[data-search-input]', pop);
    var results = $('[data-search-results]', pop);
    var clear = $('[data-search-clear]', pop);
    var idle = results ? results.innerHTML : '';
    var timer = null;
    var controller = null;
    var lastQuery = '';

    function reset() {
      results.innerHTML = idle;
      input.setAttribute('aria-expanded', 'false');
      clear.hidden = true;
    }

    function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = T.routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,page,article&resources[limit]=6' +
        '&section_id=predictive-search';

      results.setAttribute('aria-busy', 'true');
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = $('[data-predictive-inner]', doc);
          results.innerHTML = inner ? inner.innerHTML : '';
          results.removeAttribute('aria-busy');
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function (e) {
          if (e.name === 'AbortError') return;
          results.removeAttribute('aria-busy');
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) { reset(); lastQuery = ''; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      timer = setTimeout(function () { run(q); }, 220);
    });

    clear.addEventListener('click', function () {
      input.value = ''; lastQuery = ''; reset(); input.focus();
    });

    /* arrow keys walk the results, Enter follows the highlighted one */
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var hits = $$('[data-search-hit]', results);
      if (!hits.length) return;
      e.preventDefault();
      hits[e.key === 'ArrowDown' ? 0 : hits.length - 1].focus();
    });

    results.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var hits = $$('[data-search-hit]', results);
      var i = hits.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (next < 0) { input.focus(); return; }
      (hits[next] || hits[hits.length - 1]).focus();
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-search]');
      if (!opener) return;
      e.preventDefault();
      openPanel(pop, opener);
      setTimeout(function () { input.focus(); input.select(); }, 60);
    });

    /* "/" opens search, the way most stores people already use do it */
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey) return;
      var tag = (document.activeElement.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || document.activeElement.isContentEditable) return;
      e.preventDefault();
      openPanel(pop, document.activeElement);
      setTimeout(function () { input.focus(); }, 60);
    });
  }

  /* ------------------------------------------------ announcement bar */
  function initAnnouncement(root) {
    var bars = $$('[data-announcement]', root === document ? document : root.parentNode || document);
    if (root !== document && root.matches && root.matches('[data-announcement]')) bars.push(root);

    bars.forEach(function (bar) {
      if (bar.dataset.wired === 'true') return;
      bar.dataset.wired = 'true';

      var slides = $$('[data-announce-slide]', bar);
      if (slides.length < 2) return;

      var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (index < 0) index = 0;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wantsAuto = bar.getAttribute('data-autoplay') === 'true' && !reduced;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      var timer = null;
      var hovered = false;
      var focused = false;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === index;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
      }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (!wantsAuto || hovered || focused || document.hidden) return;
        timer = setInterval(function () { show(index + 1); }, interval);
      }

      var prev = $('[data-announce-prev]', bar);
      var next = $('[data-announce-next]', bar);
      if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); start(); });

      /* Pause while the visitor is reading it, or tabbing through it.
         Only a KEYBOARD focus pauses — a mouse click leaves focus on the arrow,
         which would otherwise stop the rotation for good. */
      bar.addEventListener('mouseenter', function () { hovered = true; stop(); });
      bar.addEventListener('mouseleave', function () { hovered = false; start(); });
      bar.addEventListener('focusin', function (e) {
        var el = e.target;
        var keyboard = true;
        try { keyboard = el.matches(':focus-visible'); } catch (err) { /* older engines */ }
        if (keyboard) { focused = true; stop(); }
      });
      bar.addEventListener('focusout', function () { focused = false; start(); });
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      start();
    });
  }

  /* ------------------------------------------------------------- boot */
  function boot(root) {
    root = root || document;
    initTabs(root);
    initGallery(root);
    initAnnouncement(root);
    if (root === document) { initSticky(); initSearch(); }
    if (window.initProductForm) window.initProductForm(root);
    if (window.initPricingPlans) window.initPricingPlans(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  /* Theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.themeBoot = boot;
  window.themeToast = toast;
})();
